import axios from 'axios'
import Auth from './auth'
import TStorage from 'src/scripts/Storage'

const Repository = axios.create({
  baseURL: process.env.REACT_APP_SERVER_REPOSITORY_URL,
})

Repository.interceptors.request.use(
  config => {
    const token = TStorage.AccessToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => Promise.reject(error),
)

Repository.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config

    // Check for 401 and ensure we haven't already tried to retry this request
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true

      try {
        const oldAccess = TStorage.AccessToken()
        const refresh = TStorage.RefreshToken()

        // 1. Perform the refresh
        await Auth.refreshToken(oldAccess, refresh)

        // 2. IMPORTANT: Fetch the NEW token from storage after the refresh call
        const newAccess = TStorage.AccessToken()

        // 3. Update the instance AND the current failed request
        Repository.defaults.headers.common['Authorization'] = `Bearer ${newAccess}`
        originalRequest.headers['Authorization'] = `Bearer ${newAccess}`

        // 4. Retry the original request
        return Repository(originalRequest)
      } catch (refreshError) {
        // If refresh fails (e.g. refresh token expired), clear storage/logout
        // TStorage.clear();
        return Promise.reject(refreshError)
      }
    }

    return Promise.reject(error)
  },
)

export default Repository
